<template>
    <nav class="navbar navigation navbar-expand-lg">
        <div class="container">

            <!-- Brand -->
            <router-link class="navbar-brand" :to="{ path: getHome(translatable, locality) }">
                <img src="/app/images/logo/logo.png" :alt="getSnippets('Company')">
            </router-link>

            <!-- Toggler -->
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#Navigation" aria-controls="Navigation" aria-expanded="false" aria-label="Toggle navigation" v-bind:class="[toggle ? 'active' : '']" @click="toggleNavigation($event)">
                <span></span>
                <span></span>
                <span></span>
            </button>

            <!-- Navigation Content -->
            <div class="collapse navbar-collapse" id="Navigation">
                <div class="navbar-content">
                    <ul class="navbar-nav">
                        <li class="nav-item" v-for="item in main" :key="item.id">
                            <router-link class="nav-link" :to="{ path: item.slug }">{{ item.translations[locality].title }}</router-link>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </nav>
</template>

<script>
    /* Mixins */
    import { Default } from '@mixins/Default'

    /* Components */
    import Languages from '@components/App/Partials/Languages'

    /* Logic */
    export default {
        name: "Navigation",
        mixins: [Default],
        props: [
            'currency',
            'locality',
            'navigation',
            'snippets',
            'slugs',
            'translatable',
        ],
        components: {
            'Languages': Languages
        },
        data: function () {
            return {
                main: '',
                bottom: '',
                both: '',
                shop: '',
                toggle: false
            }
        },
        methods: {
            fetchItems: function () {
                this.main = this.navigation.main
                this.bottom = this.navigation.bottom
                this.both = this.navigation.both
                this.shop = this.navigation.shop
            },
            toggleNavigation: function (event) {
                this.toggle === true ? $('body').removeClass('overflow-hidden') : this.toggle = $('body').addClass('overflow-hidden')
                this.toggle === true ? this.toggle = false : this.toggle = true
                event.preventDefault()
            }
        },
        watch: {
            locality: function () {
                this.initialize()
                this.fetchItems()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/App/Partials/Navigation.vue